/**
 * @module Tooltip
 * @description Renders a Tippy tooltip given a legal disclosure hash
 */
import { useContext, useEffect, useState } from "react";
import { ContentProviderContext } from "@/providers/content-provider";
import Tippy from "@tippyjs/react";
import setHtml from "@/js/utils/setHtml";
import "tippy.js/dist/tippy.css";
import classNames from "classnames";

/**
 * @function Component
 * @description
 */
const Component = ({ ...props }) => {
  const { disclosure = "", placement = "auto", colorOverrideClass } = props;
  const { disclosures } = useContext(ContentProviderContext);
  const [content, setContent] = useState("");

  useEffect(() => {
    if (!disclosures?.length) {
      // If no disclosures available, use the disclosure prop as content
      setContent(disclosure);
      return;
    }

    const legal = disclosures.filter((d) => d.hash === disclosure)[0];

    // If a matching disclosure is found, use its content; otherwise use the disclosure prop as content
    setContent(legal?.full ?? disclosure);
  }, [disclosure, disclosures]);

  if (!content) return null;

  return (
    <Tippy
      key="tooltip-1"
      content={
        <p
          key="paragraph-1"
          className="tooltip-content--legal"
          {...setHtml(content)}
        />
      }
      placement={placement}
      arrow={true}
      trigger="mouseenter focus click"
      theme="light"
      className="tooltip-icon"
      interactive={true}
      allowHTML={true}
      appendTo={document.body}
      {...props}
    >
      <button
        className={classNames("tooltip-btn", colorOverrideClass)}
        role="button"
      >
        <span className="icon icon-info-outline" />
        <span className="screen-reader-text">Tooltip Icon</span>
      </button>
    </Tippy>
  );
};

export default Component;
